import * as React from 'react';

import ShareButtonWithModal from 'bundles/shared-articles/components/ArticleShareButtonWithModal';
import ByLine from 'bundles/shared-articles/components/ByLine';
import getSocialCaptions from 'bundles/shared-articles/utils/getSocialCaptions';

import _t from 'i18n!nls/shared-articles';

type Props = {
  authorNames?: string;
  date: string;
  title: string;
};

const ArticleByLine = ({ authorNames, date, title }: Props) => (
  <ByLine
    authorNames={authorNames}
    date={date}
    shareButtonComponent={
      <ShareButtonWithModal
        rootClassName="share-button"
        title={_t('Share this article')}
        disableDescription
        captions={getSocialCaptions({
          articleTitle: title,
        })}
        utmMediumParam="page_share"
        utmContentParam="article"
        utmCampaignParam="sharing_cta"
      />
    }
  />
);

export default ArticleByLine;
